import React from 'react';

interface KidsaCtaProps {
  subtitle?: string;
  title?: string;
  backgroundImage?: string;
  ctaImage?: string;
  ctaShape?: string;
  ctaButtonText?: string;
  ctaButtonLink?: string;
  planeShape?: string;
  pencilShape?: string;
}

const KidsaCta: React.FC<KidsaCtaProps> = ({
  subtitle,
  title,
  backgroundImage,
  ctaImage,
  ctaShape,
  ctaButtonText,
  ctaButtonLink,
  planeShape,
  pencilShape
}) => {
  return (
    <section 
      className="cta-section fix section-padding bg-cover" 
      style={{ backgroundImage: `url('${backgroundImage}')` }}
      id="admision"
    >
      <div className="plane-shape">
        <img src={planeShape} alt="img" />
      </div>
      <div className="pencil-shape wow fadeInUp" data-wow-delay=".3s">
        <img src={pencilShape} alt="img" />
      </div>
      <div className="container">
        <div className="cta-wrapper">
          <div className="row justify-content-between">
            <div className="col-lg-6">
              <div className="section-title">
                <span className="text-white wow fadeInUp">{subtitle}</span>
                <h2 
                  className="text-white wow fadeInUp text-transform-none" 
                  data-wow-delay=".3s"
                  dangerouslySetInnerHTML={{ __html: title || '' }}
                />
              </div>
              <div className="cta-button mt-4 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                <a href={ctaButtonLink} className="theme-btn bg-white theme-btn-2">
                  {ctaButtonText} <i className="fa-solid fa-arrow-right-long"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-5 wow fadeInUp" data-wow-delay=".4s">
              <div className="cta-image">
                <img src={ctaImage} alt="cta-img" />
                <div className="cta-shape">
                  <img src={ctaShape} alt="img" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KidsaCta;
